<template>
    <Internal>

        <BreadcrumbsComponent :pages="pages" :is-dashboard="false"/>
        <div class="grid gap-4 grid-cols-9">
            <div class="col-span-9">
                <Table :fields="fields"
                       :items="vivas"
                       :canView="true"
                       :empty_message="`Vivas not found`"
                >
                    <template #teacher="{item}">

                        <inertia-link class="text-blue-600 hover:!underline"
                                      :href="route('administrative.faculty.view',item.faculty.id)"
                                      v-if="hasRole('View Faculty')">
                            {{ item.faculty.first_name }} {{ item.faculty.middle_name }} {{ item.faculty.last_name }}
                        </inertia-link>
                        <p v-else class="cursor-not-allowed">
                            {{ item.faculty.first_name }} {{ item.faculty.middle_name }} {{ item.faculty.last_name }}
                        </p>
                    </template>
                    <template #remark="{item}">
                        {{ item.marked_students?.[0]?.remark ?? "-" }}
                    </template>
                    <template #viva_at="{item}">
                        {{ tableDate(item.viva_at) }}
                    </template>
                    <template #total="{item}">
                        {{ item.marked_students?.[0]?.marks ?? "N/A" }} / {{ item.total_marks }}
                    </template>
                    <template #action="{item}">
                        <inertia-link
                            :href="`${route(`internal.admission.view.viva`, [branch.id, admission.id])}?item=${item.id}`">
                            <Button>
                                View Marks
                            </Button>
                        </inertia-link>
                    </template>
                </Table>
            </div>
        </div>

    </Internal>
</template>
<script setup>

import Internal from "@/Pages/Internal/Internal.vue";
import {usePage} from "@inertiajs/inertia-vue3";
import Table from "@/Components/Table.vue";
import Button from "@/Components/Button.vue";
import {computed} from "vue";
import {tableDate} from "../../../../../Utils/Common";
import {capitalize} from "@vue/shared";
import {hasRole} from "../../../../../Utils/checkPermission";
import BreadcrumbsComponent from "@/Components/BreadcrumbsComponent.vue";

const vivas = usePage().props.value.vivas ?? [];
const admission = usePage().props.value?.admission ?? {};
const branch = usePage().props.value?.branch ?? {};
const viva = usePage().props.value?.viva ?? null;
// const type = usePage().props.value?.type ?? null;
const students = computed(() => {
    let _students = viva?.marked_students ?? [];
    _students = _students.map((item) => {
        const {student, ...rest} = item;
        return {...student, submission: rest}
    })
    return [..._students, ...viva.not_submitted_students];
})
const fields = [
    {'key': 'title', 'label': 'title'},
    {'key': 'teacher', 'label': 'Teacher'},
    {'key': 'total', 'label': 'Marks'},
    {'key': 'remark', 'label': 'Remark'},
    {'key': 'viva_at', 'label': 'Date'},
    // {'key': 'action', 'label': 'Action'}
];
const pages = [
    {name: 'Admissions', href: route('internal.admission.list',branch.id), current: false},
    {
        name: ` ${admission?.student?.first_name} ${admission?.student?.last_name}`,
        href: `${route('internal.admission.view', [branch.id, admission.id])}?activeTab=Performance`,
        current: false
    },
    {name: 'Vivas', current: true},
]
</script>
